module.exports = __webpack_public_path__ + "static/media/barberscape-logo.3b93e50c.png";